import React from 'react';
import PropTypes from 'prop-types';

import starActive from '../../images/icons/icon_reviewstar_active.png';
import starInactive from '../../images/icons/icon_reviewstar_inactive.png';

import {
  MIN_REVIEWS_TO_SHOW_RATING,
} from '../../constants/';

const maxRating = 5;

const RatingDisplay = ({ rating, big, showTotal, totalRatings }) => {
  const roundedRating = Math.round(parseFloat(rating));
  let classStr = 'fe-rating-star';
  if(big) {
    classStr = 'fe-rating-star big';
  }
  return (
    <div className="fe-rating-widget">
      {[...Array(roundedRating)].map((_, idx) => (
        <span key={idx} className={classStr}>
          <img src={starActive} alt=""/>
        </span>
      ))}
      {[...Array(maxRating - roundedRating)].map((_, idx) => (
        <span key={idx} className={classStr}>
          <img src={starInactive} alt=""/>
        </span>
      ))}
      {showTotal && totalRatings >= MIN_REVIEWS_TO_SHOW_RATING ?
        <div className="fe-rating-widget-total">
          { totalRatings }
        </div> : null}
    </div>
  );
};

RatingDisplay.propTypes = {
  rating: PropTypes.oneOfType([
    PropTypes.number,
    PropTypes.string,
  ]).isRequired,
  big: PropTypes.bool.isRequired,
  showTotal: PropTypes.bool.isRequired,
  totalRatings: PropTypes.number,
};

RatingDisplay.defaultProps = {
  big: false,
  totalRatings: 0,
  showTotal: false,
};

export default RatingDisplay;